import { toast } from "react-hot-toast";
import { Loading } from "../components/common/loading";

export default class Spinner {
    static classInstance: Spinner
    static getInstance() {
        return this.classInstance;
    }
    spinCounter: number = 0;

    showSpinner() {
        this.spinCounter++;
        if (this.spinCounter === 1) {
            toast.custom(<Loading />, { duration: Infinity });
        }
    }

    hideSpinner() {
        this.spinCounter--;
        if (this.spinCounter === 0) {
            toast.remove();
        }
    }
}